import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/triangular/cdf';
import __var_2__ from '@stdlib/stats/base/dists/triangular/ctor';
import __var_3__ from '@stdlib/stats/base/dists/triangular/entropy';
import __var_4__ from '@stdlib/stats/base/dists/triangular/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/triangular/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/triangular/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/triangular/mean';
import __var_8__ from '@stdlib/stats/base/dists/triangular/median';
import __var_9__ from '@stdlib/stats/base/dists/triangular/mgf';
import __var_10__ from '@stdlib/stats/base/dists/triangular/mode';
import __var_11__ from '@stdlib/stats/base/dists/triangular/pdf';
import __var_12__ from '@stdlib/stats/base/dists/triangular/quantile';
import __var_13__ from '@stdlib/stats/base/dists/triangular/skewness';
import __var_14__ from '@stdlib/stats/base/dists/triangular/stdev';
import __var_15__ from '@stdlib/stats/base/dists/triangular/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace triangular
*/
var triangular = {};

/**
* @name cdf
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/cdf}
*/
setReadOnly( triangular, 'cdf', __var_1__);

/**
* @name Triangular
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/ctor}
*/
setReadOnly( triangular, 'Triangular', __var_2__);

/**
* @name entropy
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/entropy}
*/
setReadOnly( triangular, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/kurtosis}
*/
setReadOnly( triangular, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/logcdf}
*/
setReadOnly( triangular, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/logpdf}
*/
setReadOnly( triangular, 'logpdf', __var_6__);

/**
* @name mean
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/mean}
*/
setReadOnly( triangular, 'mean', __var_7__);

/**
* @name median
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/median}
*/
setReadOnly( triangular, 'median', __var_8__);

/**
* @name mgf
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/mgf}
*/
setReadOnly( triangular, 'mgf', __var_9__);

/**
* @name mode
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/mode}
*/
setReadOnly( triangular, 'mode', __var_10__);

/**
* @name pdf
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/pdf}
*/
setReadOnly( triangular, 'pdf', __var_11__);

/**
* @name quantile
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/quantile}
*/
setReadOnly( triangular, 'quantile', __var_12__);

/**
* @name skewness
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/skewness}
*/
setReadOnly( triangular, 'skewness', __var_13__);

/**
* @name stdev
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/stdev}
*/
setReadOnly( triangular, 'stdev', __var_14__);

/**
* @name variance
* @memberof triangular
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/triangular/variance}
*/
setReadOnly( triangular, 'variance', __var_15__);


// EXPORTS //
export default triangular;

export { __var_1__ as cdf, __var_2__ as Triangular, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pdf, __var_12__ as quantile, __var_13__ as skewness, __var_14__ as stdev, __var_15__ as variance};